module.exports = __webpack_public_path__ + "Wireframes16.png?4fe3b05a18b1f4d0cbb29038fdcfa697";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes16.png
// module id = 115
// module chunks = 0